import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'
import { ClerkProvider } from '@clerk/react'
import { dark } from '@clerk/themes'

Sentry.init({
  dsn: 'https://f52dfe17bdf9e122ca940e51196abac9@o4511161507512320.ingest.de.sentry.io/4511161509544016',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
  release: `book-tracker@${import.meta.env.VITE_APP_VERSION || 'dev'}`,
})

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <ClerkProvider
            afterSignOutUrl="/"
            appearance={{
                baseTheme: dark,
                variables: {
                    colorPrimary: '#d4aa34',
                    colorBackground: '#1a1f26',
                    colorInputBackground: '#0f1419',
                    colorInputText: '#e8eaed',
                    colorTextSecondary: '#9aa0a6',
                    borderRadius: '0.375rem',
                    fontSize: '0.875rem',
                },
                elements: {
                    formFieldInput: {
                        backgroundColor: '#0f1419',
                        border: '1px solid #2d3540',
                        borderRadius: '0.375rem',
                        color: '#e8eaed',
                        fontSize: '0.875rem',
                        padding: '0.5rem 0.75rem',
                        outline: 'none',
                        transition: 'border-color 0.15s',
                        '&:focus': { borderColor: '#d4aa34' },
                        '&::placeholder': { color: '#6e7681' },
                    },
                    card: {
                        backgroundColor: '#1a1f26',
                        border: '1px solid #2d3540',
                        borderRadius: '0.5rem',
                    },
                    socialButtonsBlockButton: {
                        backgroundColor: '#1a1f26',
                        border: '1px solid #2d3540',
                        borderRadius: '0.375rem',
                        padding: '0.625rem 1rem',
                        transition: 'all 0.15s',
                        '&:hover': {
                            backgroundColor: '#252d38',
                            borderColor: '#3d4654',
                        },
                    },
                    formButtonPrimary: {
                        backgroundColor: '#d4aa34',
                        borderRadius: '0.375rem',
                        fontSize: '0.875rem',
                        fontWeight: '500',
                        '&:hover': { filter: 'brightness(0.9)' },
                    },
                    footerActionLink: { color: '#d4aa34' },
                },
            }}
        >
            <App />
        </ClerkProvider>
    </StrictMode>,
)
